import { sendGTMEvent } from './googleTagManager'
import logger from 'shared/logger'

const log = logger().child({
  namespace: 'webVitals'
})

export type WebVitalsMetricName = 'TTFB' | 'FCP' | 'LCP' | 'FID' | 'CLS'

interface WebVitalsMetric {
  name: WebVitalsMetricName
  value: number
  delta?: number
  navigationType?: 'navigate' | 'reload' | 'back_forward' | 'prerender'
  rating?: 'good' | 'needs-improvement' | 'poor'
}

/**
 * Reports a web vital metric to Google Tag Manager.
 * @param metric - The web vital metric to report - comes from the useReportWebVitals hook
 */
export const reportWebVitalsToGTM = (metric: WebVitalsMetric): void => {
  try {
    sendGTMEvent({
      event: metric.name,
      metric_name: metric.name,
      metric_value: metric.value,
      metric_delta: metric.delta,
      metric_rating: metric.rating,
      navigation_type: metric.navigationType
    })

    log.debug(
      {
        metric_name: metric.name,
        metric_value: metric.value,
        metric_rating: metric.rating
      },
      'Web vital reported'
    )
  } catch (error) {
    log.error(
      {
        metric_name: metric.name
      },
      `Error reporting web vital: ${(error as Error).message}`
    )
  }
}
